<script setup lang="ts">
const props = defineProps<{
  rating: number
  maxStars?: number
  size?: 'sm' | 'md' | 'lg'
}>()

const maxStars = props.maxStars || 5
const stars = computed(() => {
  const fullStars = Math.floor(props.rating)
  const hasHalfStar = props.rating % 1 >= 0.5
  const emptyStars = maxStars - fullStars - (hasHalfStar ? 1 : 0)

  return {
    full: Array(fullStars).fill('★'),
    half: hasHalfStar ? ['★'] : [],
    empty: Array(emptyStars).fill('☆')
  }
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm': return 'text-sm'
    case 'lg': return 'text-xl'
    default: return 'text-base'
  }
})
</script>

<template>
  <div class="flex items-center">
    <div
      v-for="(star, index) in stars.full"
      :key="`full-${index}`"
      :class="sizeClasses"
    >
      {{ star }}
    </div>
    <div
      v-for="(star, index) in stars.half"
      :key="`half-${index}`"
      :class="sizeClasses"
    >
      {{ star }}
    </div>
    <div
      v-for="(star, index) in stars.empty"
      :key="`empty-${index}`"
      :class="sizeClasses"
    >
      {{ star }}
    </div>
  </div>
</template>
